import { c as _c } from "react/compiler-runtime";
// 결과 카드 패러디 화면(404·에러)에서 쓰는 특성 게이지 바.
// no-emoji 정책 — 시각 요소는 CSS 바만 사용한다.
export default function TraitBar(t0) {
  const $ = _c(10);
  const {
    label,
    percent
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="w-24 shrink-0 text-left text-xs font-display text-slate-600">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${percent}%`;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-brand-100"><div className="h-full rounded-full bg-brand-gradient" style={{
        width: t2
      }} /></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== percent) {
    t4 = <span className="w-10 shrink-0 text-right text-xs tabular-nums text-slate-500">{percent}%</span>;
    $[4] = percent;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex items-center gap-3">{t1}{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}